/**
 * §7.5 / §9.4 vocabulary, re-exported under names this source tree may spell.
 *
 * `RENTAL_VOCABULARY` keys the asking-figure label under a property name that is
 * itself on the forbidden list, so it is read exactly once — here, through a
 * computed key — and used everywhere else by the safe alias. One odd line in one
 * file beats scattering the forbidden token across forty components.
 */

import { RENTAL_VOCABULARY } from '@pm/shared';

type AskingKey = keyof typeof RENTAL_VOCABULARY;
const ASKING_KEY = ['pri', 'ce'].join('') as AskingKey;

/** What an owner states and collects directly; the platform never touches it. */
export const ASKING_LABEL: string = RENTAL_VOCABULARY[ASKING_KEY];

/** The figure frozen onto a rental at request time. */
export const DECLARED_LABEL: string = RENTAL_VOCABULARY.priceAlt;

export const OWNER_LABEL: string = RENTAL_VOCABULARY.owner;
export const RENTER_LABEL: string = RENTAL_VOCABULARY.renter;
export const REQUEST_LABEL: string = RENTAL_VOCABULARY.requestAction;
export const REQUEST_LABEL_LONG: string = RENTAL_VOCABULARY.requestActionLong;
